import FormBase from "../../forms/FormBase";
import FormFieldAttachmentBase, { FieldAttachment} from "../../forms/FormFieldAttachmentBase";

export type SubTypeAttachment = "Insert" | "Delete" | "UpdateId" | "Error" | "Loading";

//Método responsavel por fazer o crud da inserção de arquivos
const updateFileActions = (form: FormBase, name: string, value: FieldAttachment, subType: SubTypeAttachment, errorMessage?: string, id?: string, loading?: boolean) => {

  switch (subType) {
    case "Insert":
      const files = [...(form.GetFieldByName(name) as FormFieldAttachmentBase).Values];
      files.push(value);
      (form.GetFieldByName(name) as FormFieldAttachmentBase).Values = files;
      break;

    case "Delete":
      var index = (form.GetFieldByName(name) as FormFieldAttachmentBase).Values.findIndex((f) => f.HashName === value.HashName);
      const newFiles = [...(form.GetFieldByName(name) as FormFieldAttachmentBase).Values];
      newFiles.splice(index, 1);
      (form.GetFieldByName(name) as FormFieldAttachmentBase).Values = newFiles;
      break;

    case "Loading":
      if (loading) {
        let index = (form.GetFieldByName(name) as FormFieldAttachmentBase).Values.findIndex((f) => f.HashName === value.HashName);
        const newFiles = [...(form.GetFieldByName(name) as FormFieldAttachmentBase).Values];
        newFiles[index].IsLoading = loading;
        (form.GetFieldByName(name) as FormFieldAttachmentBase).Values = newFiles;
      }
      break;

    case "UpdateId":
      if (id) {
        let index = (form.GetFieldByName(name) as FormFieldAttachmentBase).Values.findIndex((f) => f.HashName === value.HashName);
        const newFiles = [...(form.GetFieldByName(name) as FormFieldAttachmentBase).Values];
        newFiles[index].Id = id;
        (form.GetFieldByName(name) as FormFieldAttachmentBase).Values = newFiles;
      }
      break;

    case "Error":
      if (errorMessage) {
        let index = (form.GetFieldByName(name) as FormFieldAttachmentBase).Values.findIndex((f) => f.HashName === value.HashName);
        const newFiles = [...(form.GetFieldByName(name) as FormFieldAttachmentBase).Values];
        newFiles[index].ErrorMessage = errorMessage;
        (form.GetFieldByName(name) as FormFieldAttachmentBase).Values = newFiles;
      }
      break;
    default:
      break;
  }

  (form.GetFieldByName(name) as FormFieldAttachmentBase).ValidateField();
}


const exportedObject = {
  updateFileActions,
};


export default exportedObject